import { ReactNode } from 'react'
import { useAuth as useClerkAuth, useUser } from '@clerk/clerk-react'
import { LogOut } from 'lucide-react'
import { performBackofficeLogout } from '../../lib/entryContext'

export default function OnboardingLayout({ children }: { children: ReactNode }) {
  const { signOut } = useClerkAuth()
  const { user } = useUser()

  return (
    <div className="min-h-dvh bg-background text-foreground">
      <header className="border-b border-border px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-gradient-to-tr from-accent to-accent-strong flex items-center justify-center shadow-md">
            <span className="text-white font-bold text-sm">CH</span>
          </div>
          <span className="font-display font-bold text-lg tracking-tight">
            Comfort<span className="text-accent">Hub</span>
          </span>
        </div>
        <div className="flex items-center gap-3">
          {user?.primaryEmailAddress?.emailAddress && (
            <span className="text-xs text-foreground-muted hidden sm:inline">{user.primaryEmailAddress.emailAddress}</span>
          )}
          <button
            type="button"
            onClick={() => performBackofficeLogout(signOut)}
            className="inline-flex items-center gap-1.5 rounded-xl border border-border px-3 py-1.5 text-xs font-semibold text-foreground-muted hover:text-foreground hover:bg-surface-hover transition-colors"
          >
            <LogOut size={14} />
            Log out
          </button>
        </div>
      </header>
      <main className="max-w-2xl mx-auto px-4 py-8 md:py-12">{children}</main>
    </div>
  )
}
